import { inject, Injectable } from '@angular/core';
import { ApplicationStore, ApplicationStoreType } from './application.store';

@Injectable({ providedIn: 'root' })
export class StoreManager {
    private applicationStore: ApplicationStoreType = inject(ApplicationStore);

    public resetState() {
        this.applicationStore.resetState();
    }
}
